export const teachAssistant = [
  {
    path: '/assistantHome',
    name: 'assistantHome',
    component: () => import('views/teachAssistant/assistantHome/index'),
    meta: {
      title: '小助教'
    }
  },
  {
    path: '/assistantHome/signInClass',
    name: 'signInClass',
    component: () => import('views/teachAssistant/signInClass/index'),
    meta: {
      title: '上课签到'
    }
  },
  {
    path: '/assistantHome/signInClass/courseSignIn',
    name: 'courseSignIn',
    component: () => import('views/teachAssistant/signInClass/courseSignIn/index'),
    meta: {
      title: '课程签到'
    }
  },
  {
    path: '/assistantHome/signInClass/signInRecord',
    name: 'signInRecord',
    component: () => import('views/teachAssistant/signInClass/signInRecord/index'),
    meta: {
      title: '签到记录',
      keepAlive: true
    }
  },
  {
    path: '/assistantHome/signInClass/signInRecord/signInDetail',
    name: 'signInDetail',
    component: () => import('views/teachAssistant/signInClass/signInDetail/index'),
    meta: {
      title: '签到详情'
    }
  },
  {
    path: '/assistantHome/studentList',
    name: 'studentList',
    component: () => import('views/teachAssistant/studentList/index'),
    meta: {
      title: '学员管理'
    }
  },
  {
    path: '/assistantHome/studentList/studentDetail',
    name: 'studentDetail',
    component: () => import('views/teachAssistant/studentList/studentDetail/index'),
    meta: {
      title: '学员详情'
    }
  },
  {
    path: '/assistantHome/studentList/historyStudent',
    name: 'historyStudent',
    component: () => import('views/teachAssistant/studentList/historyStudent/index'),
    meta: {
      title: '往期学员'
    }
  },
  {
    path: '/assistantHome/classList',
    name: 'classList',
    component: () => import('views/teachAssistant/classList/index'),
    meta: {
      title: '课程管理'
    }
  },
  {
    path: '/assistantHome/classList/addCourse',
    name: 'addCourse',
    component: () => import('views/teachAssistant/classList/addClass/index'),
    meta: {
      title: '添加课程',
      keepAlive: true
    }
  },
  {
    path: '/assistantHome/classList/addCourse/richText',
    name: 'richText',
    component: () => import('views/teachAssistant/classList/richText/index'),
    meta: {
      title: '图文详情'
    }
  },
  {
    path: '/assistantHome/teacherList',
    name: 'teacherList',
    component: () => import('views/teachAssistant/teacherList/index'),
    meta: {
      title: '老师管理'
    }
  },
  {
    path: '/assistantHome/classOrder',
    name: 'classOrder',
    component: () => import('views/teachAssistant/classOrder/index'),
    meta: {
      title: '课程订单',
      keepAlive: true
    }
  },
  {
    path: '/assistantHome/classOrder/classOrderDetail',
    name: 'classOrderDetail',
    component: () => import('views/teachAssistant/classOrder/classOrderDetail/index'),
    meta: {
      title: '订单详情'
    }
  }
]
